import React from 'react';
import { BRAND, isMarketGB } from '../../constants/main';
import { TrimItemStyledAC } from './AC/TrimItemStyled.AC';
import { TrimItemStyledACGB } from './AC/GB/TrimItemStyled.AC';
import { TrimItemStyledOV } from './OV/TrimItemStyled.OV';
import { TrimItemStyledOVGB } from './OV/TrimItemStyled.OVGB';
import { TrimItemStyledAP } from './AP/TrimItemStyled.AP';
import { TrimItemStyledDS } from './DS/TrimItemStyled.DS';
import { TrimItemStyled } from './TrimItemStyled';
import { SC } from '../../styles/theme';
import { ITrimItem, ITrimConfiguration } from '../../redux/trimSelector/trimSelector.duck.interface';

export type TrimItemProps = SC & {
    trim: ITrimItem;
    query?: any;
    disabled?: boolean;
    trimConfiguration: ITrimConfiguration;
    areCharacteristicsOpen?: boolean;
    usingFilters: boolean;
    newRef: any;
    index?: number;
    isMarketingStickerExists?: boolean;
    childRef?: {
        [key: string]: React.Ref<HTMLDivElement>;
    };
};

const TrimItem = (props: TrimItemProps) => {
    if (BRAND === 'OV') return isMarketGB ? <TrimItemStyledOVGB {...props} /> : <TrimItemStyledOV {...props} />;
    if (BRAND === 'AC') return isMarketGB ? <TrimItemStyledACGB {...props} /> : <TrimItemStyledAC {...props} />;
    if (BRAND === 'AP') return <TrimItemStyledAP {...props} />;
    if (BRAND === 'DS') return <TrimItemStyledDS {...props} />;
    return <TrimItemStyled {...props} />;
};

export default TrimItem;
